<div class="layout-menu-wrapper" *ngIf="user.authenticated&&user?.info?.subtype!=UserType.Candidate" [class.layout-menu-dark]="app.darkMenu" (click)="app.onMenuClick($event)">
  <div class="nano">
    <!-- jC: OneLynk Home links -->
    <div class="sidebar-orgname">{{user?.info?.orgName}}
      <a [routerLink]="RouteLink.Profile" routerLinkActive="active" pTooltip="My Profile" (click)="this.app.overlayMenuActive=false;this.app.mobileMenuActive = false;">
        <span class="username">
          <div>{{user?.info?.fullName}}</div>
        </span>
      </a>
    </div>
    <ul class="traynav-styles" (click)="this.app.overlayMenuActive=false;this.app.mobileMenuActive = false;">
      <li>
        <a [routerLink]="RouteLink.Home" routerLinkActive="active" pTooltip="Home" tooltipPosition="left">
          <i class="fa fa-home"></i>Home</a>
      </li>
      <li>
        <a [routerLink]="RouteLink.Services" routerLinkActive="active" pTooltip="Services" tooltipPosition="left">
          <i class="fa fa-cubes"></i>Services</a>
      </li>
      <li>
        <a [routerLink]="RouteLink.Worklist" routerLinkActive="active" pTooltip="Worklist" tooltipPosition="left">
          <i class="fa fa-th-list"></i>Worklist</a>
      </li>
      <li>
        <a [routerLink]="RouteLink.Delegation" routerLinkActive="active" pTooltip="Delegation" tooltipPosition="left">
          <i class="fa fa-id-badge"></i>Delegation</a>
      </li>
      <li>
        <a [routerLink]="RouteLink.CorpCalendar" routerLinkActive="active" pTooltip="Calendar" tooltipPosition="left">
          <i class="fa fa-calendar"></i>Calendar</a>
      </li>
      <li>
        <a [routerLink]="RouteLink.Help" routerLinkActive="active" pTooltip="Help" tooltipPosition="left">
          <i class="fa fa-info"></i>Help</a>
      </li>
      <li>
        <a [routerLink]="RouteLink.Connect" routerLinkActive="active" pTooltip="Connect Chat" tooltipPosition="left">
          <i class="fa fa-users"></i>Connect</a>
      </li>
      <li>
      <a (click)="app.onClickLogout()" pTooltip="Logout" tooltipPosition="left" style="cursor:pointer;font-size:15px;text-decoration:underline;">
          <i class="fa fa-sign-out"></i>Logout</a>
      </li>


    </ul>
    <div class="nano-content sidebar-scroll-content">
      <div class="layout-menu-container">
        <ul app-submenu [item]="onelynkModel" root="true" class="layout-menu" visible="true" [reset]="reset"></ul>
      </div>
    </div>

  </div>
</div>
